module.exports = __webpack_public_path__ + "img/icon_s-1.2.b4e7f6ba.svg";